export enum SequenceType {
  Stopping = 1, // default
  Cycle = 2,
  Shuffle = 4,
  Once = 8,
}
